import React from 'react';
import { Box, Typography, withWidth, withStyles } from '@material-ui/core';
import styled from 'styled-components';
import SectionLineTitle from './../../../shared/components/SectionLineTitle';
import ArrowButtonLink from './../../../shared/components/ArrowButtonLink';
import { Form } from 'react-final-form';
import api from './../../../shared/functions/api/';
import { TextField, makeValidate, makeRequired, showErrorOnBlur } from 'mui-rff';
import * as yup from 'yup';

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "../../../redux/actions/auth";

import DynamicElement from 'shared/components/DynamicElement';
import classNames from "classnames";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const styles = (theme) => ({

});

const SectionDescription = styled.div`
    font-family: Lato;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    color: #8e8e8e;
    display: block;
`;

const schema = yup.object().shape({
    email: yup.string().required().email(),
});
const validate = makeValidate(schema);
const required = makeRequired(schema);

function RegistrationFormEmailOnly({ initialValues, onSubmitComplete, emailCheck }) {

    async function onSubmit(values) {
        const data = await emailCheck(values.email);
        if (data.exists) {
            onSubmitComplete(values, true)
        } else {
            onSubmitComplete(values, false)
        }
    }

    return (
        <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, submitting }) => (
                <form onSubmit={handleSubmit} noValidate>
                    <TextField
                        label="Email"
                        name="email"
                        fullWidth
                        required={required.email}
                        disabled={submitting}
                        showError={showErrorOnBlur}
                    />
                    <Box mt={4}>
                        <ArrowButtonLink label={'Start Registration'} submit loading={submitting} />
                    </Box>
                </form>
            )}
        />
    );
}

const HeadingTypography = styled(Typography)`
    height: 100px;
    font-family: MinionPro-Disp;
    font-size: 72px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    color: #484f57;
    padding-top: 15px;
    margin-bottom: 80px;
`;

const DoubleDiamond = styled(({ className, style }) => <svg style={style} className={className} xmlns="http://www.w3.org/2000/svg" width="243.113" height="349.239" viewBox="0 0 243.113 349.239">
    <g id="icon_branding_decor_3" transform="translate(-952.03 -918.904)">
        <path id="Path_3313" d="M528.958 146.634l-31.215 158.218-29.456 16.368 29.467 16.38 31.076 158.08 31.2-158.161 29.338-16.3-29.3-16.275z" className="cls-1" transform="translate(484.771 772.367)" />
        <path id="Path_3314" d="M528.958 146.634l-31.215 158.218-29.456 16.368 29.467 16.38 31.076 158.08 31.2-158.161 29.338-16.3-29.3-16.275z" className="cls-1" transform="translate(604.741 772.367)" />
    </g>
</svg>
)`
position: absolute;
top: 9.7%;
left: 8.7%;
.cls-1{
    fill:none;
    stroke:#b08f6e
}
`;

const ElegantQuoteTypography = styled(Typography)`
    font-family: Lato;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: 0.96px;
    color: #b6b8bc;
    margin-top: 30px;
    display: inline-block;
`;

function RegisterSection(props) {
    const { noHeightStretch, className } = props;
    return (<div id={props.id} style={{ height: noHeightStretch ? 'auto' : '100vh', display: 'flex' }} className={className}>
        <Box position="relative" pt={8} pb={8} margin="auto">

            <HeadingTypography variant="h1" align="center">
                <DynamicElement id="5ff6596f2a34245c31b64df9">
                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                </DynamicElement>
            </HeadingTypography>

            <div style={{ display: 'flex', gap: '80px' }}>
                <div style={{ width: '50%', textAlign: 'right' }}>
                    <DoubleDiamond />

                    <DynamicElement id="5ff6575f2a34245c31b64df6">
                        {({ value }) => <LazyLoadImage alt="" src={value} width={466} style={{ position: 'relative' }} />}
                    </DynamicElement>

                    <ElegantQuoteTypography align="center" style={{ width: 466 }}>
                        <DynamicElement id="5ff657b72a34245c31b64df7">
                            {({ value }) => <React.Fragment>
                                “<span dangerouslySetInnerHTML={{ __html: value }} />”
                            </React.Fragment>
                            }
                        </DynamicElement>
                    </ElegantQuoteTypography>
                </div>
                <div style={{ width: '50%' }}>
                    <Box pl={5} pt={1}>
                        <SectionLineTitle>
                            <DynamicElement id="5ff658fe2a34245c31b64df8">
                                {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                            </DynamicElement>
                        </SectionLineTitle>

                        <SectionDescription>
                            <DynamicElement id="605479d91439ae380df140c1">
                                {({ value }) => <div dangerouslySetInnerHTML={{ __html: value }} />}
                            </DynamicElement>
                        </SectionDescription>

                        <Box width={300} mt={2}>
                            <RegistrationFormEmailOnly
                                onSubmitComplete={props.onSubmitComplete}
                                emailCheck={props.AuthActions.emailCheck}
                            />
                        </Box>
                    </Box>
                </div>

            </div>


        </Box>

    </div>)
}




const MobileWrapper = styled.div`
  width: 100%;
  position: relative;

  .SectionLineTitle{
    margin-top: 100px;
    margin-right: 28px;
    width: 255px;

    font-family: MinionPro;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: normal;
  }

  .MainText{
    font-size: 55px;
    line-height: 1;
    padding-top: 28px;
    text-align: center;
    margin-bottom: 10px;
  }
  
  .bigImage{
    position: absolute;
    top: 380px;
    right: 24px;
    width: 65%;
    height: auto;

    img{
        width: 100%;
    }
  }

  .smallImage{
    position: absolute;
    top: 410px;
    left: 24px;
    width: 28%;
    height: auto;

    img{
        width: 100%;
    }
  }

  button{
    margin-left: auto;
    margin-right: auto;
    display: flex;
    margin-top: -14px;
    margin-bottom: 14px;
  }
`;

const SectionWrapper = (props) => {
    if (props.width === 'xs') {
        return <MobileWrapper className="dark-support">

            <div style={{ textAlign: 'right' }}>
                <SectionLineTitle className="SectionLineTitle">
                    <DynamicElement id="5ff658fe2a34245c31b64df8">
                        {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                    </DynamicElement>
                </SectionLineTitle>
            </div>

            <HeadingTypography variant="h1" align="center" className="MainText">
                <DynamicElement id="5ff6596f2a34245c31b64df9">
                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                </DynamicElement>
            </HeadingTypography>

            <DoubleDiamond style={{
                width: 130,
                position: 'relative',
                top: 'auto',
                height: 'auto',
                marginBottom: 90,
            }} />

            <div className="bigImage">
                <DynamicElement id="5ff6575f2a34245c31b64df6">
                    {({ value }) => <LazyLoadImage alt="" src={value} />}
                </DynamicElement>
            </div>

            <ElegantQuoteTypography align="center">
                <DynamicElement id="5ff657b72a34245c31b64df7">
                    {({ value }) => <React.Fragment>
                        “<span dangerouslySetInnerHTML={{ __html: value }} />”
                            </React.Fragment>
                    }
                </DynamicElement>
            </ElegantQuoteTypography>

            <Box p={4} pt={2}>
                <RegistrationFormEmailOnly
                    onSubmitComplete={props.onSubmitComplete}
                    emailCheck={props.AuthActions.emailCheck}
                />
            </Box>

        </MobileWrapper>;
    } else {
        return <RegisterSection {...props} className="dark-support" />
    }
}


export default React.memo(withWidth()(withStyles(styles, { withTheme: true })(connect(
    (state) => ({
        authUser: state.auth.user,
    }),
    (dispatch) => ({
        AuthActions: bindActionCreators({ ...AuthActions }, dispatch)
    })
)(SectionWrapper))));